import { IOrder, PaymentData, PaymentDataStatus } from '@app/certificates/history/history';
import { INomenclature } from '@app/core/nomenclature/nomenclature';

export enum observeTypes {
    BODY = 'body',
    RESPONSE = 'response',
    EVENTS = 'events'
}

export interface ISpringResponseBody {
    code: string;
    message: string;
    status: number;
    field?: string;
    data?: any;
}

export interface ISpringResponseType {
    status: number;
    body: ISpringResponseBody;
}

export interface IGetFileData {
    fileName: string;
    content: string;
}

export interface ISignFileData {
    fileId: string;
}

export interface IOrderPostResponse extends ISpringResponseBody {
    data: IOrder;
}

export interface IPaymentDataPostResponse extends ISpringResponseBody {
    paymentData: PaymentData;
}

export interface IPaymentDataStatusResponse extends ISpringResponseBody {
    paymentDataStatus: PaymentDataStatus;
}

export interface IPaymentStatusResponse extends ISpringResponseBody {
    data: PaymentStatusCode;
}

export enum PaymentStatusCode {
    // Нова поръчка - още не са генерирани данни за плащане
    NEW = 'NEW',
    // Нова поръчка - генерирани са данни за пращане
    // NEW_PAYMENT_DATA_GENERATED = 'SEND', //отпада

    // Очаква резултат - плащането е извършено от потребителя, но системата не знае резултата
    // Използва се при затваряне на payment gateway прозореца
    // Вътрешен статус. Не се връща от getPaymentStatus сървиса
    // WAITING_PAYMENT_SENT = 'PAYMENT_GATEWAY_CLOSED', //отпада

    // Очаква резултат - плащането е извършено от потребителя, но все още е в процес на обработка
    WAITING_PAYMENT_IN_PROGRESS = 'VOK',

    // Завършена поръчка, плащането е успешно
    FINISHED_SUCCESS = 'OK', // успешно плащане

    // Завършена поръчка, отказано плащане
    FINISHED_REJECTED = 'NOK',
    // FINISHED_REJECTED_PROBLEM = 'NOK~~',//отпада

    // Системна грешка
    ERROR = 'ERROR'
}
export interface INomenclatureResponse extends ISpringResponseBody {
    data: INomenclature;
}

export interface EmployeesServicesResponse {
    code: string;
    data: Service[];
    responseCode: string;
    status: number;
  }
  
  export interface Service {
    serviceType: string;
    nameBg: string;
    nameEn: string;
  }
  export interface WebIdentificationHistoryResponse {
    code: string;
    message: string;
    data: Identity[];
    responseCode: string;
    status: number;
  }
  
  export interface Identity {
    id: number;
    status: string;
    createdAt: number;
    identifierType: string;
    identifierValue: string;
    name: LocalizedName;
    phoneNumber: string;
    email: string;
  }
  
  export interface LocalizedName {
    bg: string;
    en: string;
  }

  export interface RequestsWebIdentificationResponse {
    id: number;
    status: string;
    createdAt: Date;
    identifierType: string | null;
    identifierValue: string | null;
    name: string | null;
    phoneNumber: string;
    email: string;
  }